export default (props: any) => {
  return (
    <img
      className="mt-4 mb-4 consultation-detail-icon"
      src="/images/subtract_icon.png"
      alt="subtract_icon"
    />
  );
};
